import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import { useNotificacoes } from '../../hooks/useNotificacoes';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ModalConfirm } from '../Components/ModalSistema';
import './notificacoes.css';

function Notificacoes() {
  const history = useHistory();
  const { lista, marcarComoLida, refetch, removerNotificacao, removerVarias, removerTodas } = useNotificacoes();
  const [selecionados, setSelecionados] = useState(new Set());
  const [confirmExcluirTodas, setConfirmExcluirTodas] = useState(false);

  useEffect(() => {
    const ok = async () => {
      const resultado = await verificandoApp('ATENDENTE');
      if (!resultado) history.push('/');
    };
    ok();
    refetch();
  }, [history, refetch]);

  const formatarData = (d) => {
    if (!d) return '';
    const dt = new Date(d);
    return dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const handleClick = (n, e) => {
    if (e.target.closest('.notif-card-checkbox') || e.target.closest('.notif-card-delete')) return;
    marcarComoLida(n.id);
    if (n.sat_num) history.push('/historicoSati/' + n.sat_num);
  };

  const toggleSelecao = (id, e) => {
    e.stopPropagation();
    setSelecionados((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const toggleSelecionarTodos = () => {
    if (selecionados.size === lista.length) setSelecionados(new Set());
    else setSelecionados(new Set(lista.map((n) => n.id)));
  };

  const excluirSelecionados = async () => {
    if (selecionados.size === 0) return;
    await removerVarias([...selecionados]);
    setSelecionados(new Set());
  };

  const solicitarExcluirTodas = () => {
    if (lista.length === 0) return;
    setConfirmExcluirTodas(true);
  };

  const excluirTodas = async () => {
    setConfirmExcluirTodas(false);
    await removerTodas();
    setSelecionados(new Set());
  };

  const excluirCard = async (id, e) => {
    e.stopPropagation();
    await removerNotificacao(id);
    setSelecionados((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="container-fluid titulo notif-page">
          <h1>Notificações</h1>
          {lista.length > 0 && (
            <div className="notif-acoes">
              <label className="notif-check-label">
                <input
                  type="checkbox"
                  checked={lista.length > 0 && selecionados.size === lista.length}
                  onChange={toggleSelecionarTodos}
                  className="notif-card-checkbox"
                  aria-label="Selecionar todas"
                />
                <span>Selecionar todas</span>
              </label>
              <button type="button" className="notif-btn notif-btn-danger" onClick={excluirSelecionados} disabled={selecionados.size === 0}>
                <i className="fas fa-trash-alt" /> Excluir selecionadas
              </button>
              <button type="button" className="notif-btn notif-btn-danger-outline" onClick={solicitarExcluirTodas}>
                <i className="fas fa-trash" /> Excluir todas
              </button>
            </div>
          )}
          <ModalConfirm
            open={confirmExcluirTodas}
            onClose={() => setConfirmExcluirTodas(false)}
            title="Excluir todas"
            message="Excluir todas as notificações?"
            confirmLabel="Sim, excluir"
            cancelLabel="Cancelar"
            onConfirm={excluirTodas}
            variant="danger"
          />
          {lista.length === 0 && <p className="text-muted">Nenhuma notificação.</p>}
          <div className="notif-lista">
            {lista.map((n) => (
              <div
                key={n.id}
                role="button"
                tabIndex={0}
                className={`notif-card ${n.lida ? 'lida' : ''}`}
                onClick={(e) => handleClick(n, e)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(n, e); }}
              >
                <div className="notif-card-header">
                  <label className="notif-card-checkbox" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      checked={selecionados.has(n.id)}
                      onChange={(e) => toggleSelecao(n.id, e)}
                      aria-label={`Selecionar notificação ${n.titulo}`}
                    />
                  </label>
                  <button
                    type="button"
                    className="notif-card-delete"
                    onClick={(e) => excluirCard(n.id, e)}
                    title="Excluir"
                    aria-label="Excluir notificação"
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
                <span className="notif-card-titulo">{n.titulo}</span>
                {n.mensagem && <p className="notif-card-msg">{n.mensagem}</p>}
                <span className="notif-card-data">{formatarData(n.created_at)}</span>
                {n.sat_num && (
                  <button
                    type="button"
                    className="notif-card-chamado"
                    onClick={(e) => { e.stopPropagation(); marcarComoLida(n.id); history.push('/historicoSati/' + n.sat_num); }}
                  >
                    Chamado #{n.sat_num}
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export default Notificacoes;
